import * as React from 'react';
import { Link } from 'react-router-dom';

import { ClickTracker } from 'bernie-analytics';
import { UitkLink, UitkLinkAlign } from 'uitk-react-link';
import { PropertyInfoPriceGuaranteeViewModel } from 'models';

const LinkTracked = ClickTracker(Link);

interface PriceGuaranteeProps {
  priceGuarantee?: PropertyInfoPriceGuaranteeViewModel;
}

export const PriceGuarantee: React.FunctionComponent<PriceGuaranteeProps> = ({ priceGuarantee }) => {
  if (!priceGuarantee) {
    return null;
  }

  const { url, description } = priceGuarantee;

  return (
    <UitkLink align={UitkLinkAlign.RIGHT}>
      <LinkTracked linkName={description} rfrr="PriceGuarantee" to={url} target="_blank">
        <span className="uitk-type-bold pwa-theme--success">{description}</span>
      </LinkTracked>
    </UitkLink>
  );
};
